export const FORM_CONTAINER_ID = "form-container";
export const SHADOW_ROOT_CONTAINER_ID = "shadow-root-container";
export const FLATPICKR_CONFIG = {
  altInput: true,
  altFormat: "d.m.Y",
  dateFormat: "Y-m-d",
};
export const MOMENT_FORMAT = "YYYY-MM-DD";
